module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3461596.b77919b1.png";